/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb1_HeadingInputs */

const en_visa_eb1_heading = /** @type {(inputs: Visa_Eb1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How We Position EB-1 Cases`)
};

const pt_visa_eb1_heading = /** @type {(inputs: Visa_Eb1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como Posicionamos Casos EB-1`)
};

const es_visa_eb1_heading = /** @type {(inputs: Visa_Eb1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cómo Posicionamos Casos EB-1`)
};

/**
* | output |
* | --- |
* | "How We Position EB-1 Cases" |
*
* @param {Visa_Eb1_HeadingInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb1_heading = /** @type {((inputs?: Visa_Eb1_HeadingInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb1_HeadingInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb1_heading(inputs)
	if (locale === "es") return es_visa_eb1_heading(inputs)
	return en_visa_eb1_heading(inputs)
});